import object from '@mailobj-browser/front/js/utils/object.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import replaceChildren from '@mailobj-browser/front/js/tree/replaceChildren.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import beforeToggle from '@mailobj-browser/front/js/events/types/beforeToggle.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { render } from '../../template/template.js'

export const onClick = object(listener, {
  type: click,
  task: async (details, event) => {
    const { target } = event
    const { children, open } = details

    if (!closest('summary', target)) {
      return
    }

    preventDefault(event)

    if (open) {
      return
    }

    const [summary, template] = children
    const content = await render(template)

    replaceChildren(details, [summary, template, content])

    /** @todo VD À supprimer lorsque l'évent beforeToggle sera entièrement supporté  */
    if (!Object.hasOwn(details, 'onbeforetoggle')) {
      const { ownerDocument } = details
      const { defaultView } = ownerDocument
      const { CustomEvent } = defaultView

      details.dispatchEvent(new CustomEvent(beforeToggle))
    }

    details.open = true
    summary.focus()
  }
})

export default template => {
  const { parentNode } = template

  onClick.listen(parentNode)
}
